<template>
    <b-modal size="xl" id="rma-part-modal" ref="rma-part-modal" @show="onClear">
        <template slot="modal-header">
            <h5 class="modal-title">{{ (isAddPart) ? 'Add Part' : 'Edit Part' }}</h5>
        </template>
        <div class="animated fadeIn requirements--requirements-list h-100">
            <div class="card-body d-flex flex-column">
                <b-row>
                    <b-col cols="2">
                        <dt>Company</dt>
                        <dd>{{ customerrma.companyName }}</dd>
                    </b-col>
                    <b-col cols="2">
                        <dt>Invoice No</dt>
                        <dd>{{ customerrma.invoiceDate }}</dd>
                    </b-col>
                    <b-col cols="2">
                        <dt>RMA Date</dt>
                        <dd>{{ date(customerrma.rmaDate) }}</dd>
                    </b-col>
                    <b-col cols="2">
                        <dt>Ship Date</dt>
                        <dd>{{ date(customerrma.returnShipping) }}</dd>
                    </b-col>
                </b-row>
                <br/>
                <div v-if="isAddPart">
                    <b-row v-for="(line, index) in invoiceLineArr" :key="index" class="mt-1">
                        <b-col>
                            <table>
                            <tr>
                                <td>
                                <input type="checkbox" :value="line.id" v-model="checkedInvoiceLineIds" />
                                </td>
                                <td>
                                <dt>Part Number</dt>
                                <dd>{{ line.partNumber || '&nbsp;' }}</dd>
                                </td>
                                <td>
                                <dt>Quantity Shipped</dt>
                                <dd>{{ line.quantity || '&nbsp;' }}</dd>
                                </td>
                                <td>
                                <dt>Date Code</dt>
                                <dd>{{ line.dateCode || '&nbsp;' }}</dd>
                                </td>
                                <td>
                                <dt>COO</dt>
                                <dd>{{ line.countryOfOriginName || '&nbsp;' }}</dd>
                                </td>
                                <td>
                                <dt>RoHS</dt>
                                <dd>{{ line.leadFree || '&nbsp;' }}</dd>
                                </td>
                                <td>
                                <dt>Lot</dt>
                                <dd>{{ line.lotCode || '&nbsp;' }}</dd>
                                </td>
                                <td>
                                <dt>Revision</dt>
                                <dd>{{ line.revision || '&nbsp;' }}</dd>
                                </td>
                                <td>
                                <dt>Packaging</dt>
                                <dd>{{ line.package || '&nbsp;' }}</dd>
                                </td>
                                <td>
                                <dt>SPQ</dt>
                                <dd>{{ line.piecePerPkg || '&nbsp;' }}</dd>
                                </td>
                            </tr>
                            </table>
                            <div class="d-flex justify-content-start align-items-end mb-2" v-if="checkedInvoiceLineIds.indexOf(line.id) > -1">
                                <b-form-group label="Quantity Returned" class="mr-2">
                                    <b-form-input type="number" :max="line.quantity" v-model="line.returnQty" size="sm"
                                    @blur="line.returnQty = line.returnQty > line.quantity ? line.quantity : line.returnQty < 0 ? 0 : line.returnQty" />
                                </b-form-group>
                                <b-form-group label="Reason of Returning" class="mr-2" >
                                    <b-form-select v-model="line.returnReasonId" size="sm">
                                    <option v-for="(item) in sortSelect(rmaReasons)" :key="item.id" :value="item.id">{{item.name}}</option>
                                    </b-form-select>
                                </b-form-group>
                                <b-form-group label="Comments" class="mr-2">
                                    <b-form-input v-model="line.returnComments" size="sm" />
                                </b-form-group>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <div v-else>
                    <div class="d-flex flex-column">
                        <b-row>
                            <b-col cols="9">
                                <b-row>
                                    <b-col cols="4">
                                        <b-form-group label="Part #" class="mr-2">
                                            <b-form-input v-model="rmaPart.partNumber" :disabled="true" class="form-control" />
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="8">
                                        <b-form-group label="Description" class="mr-2" width="500">
                                            <b-form-input v-model="rmaPart.description" :disabled="true" class="form-control" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="4">
                                        <b-form-group label="Customer PN" class="mr-2">
                                            <b-form-input v-model="rmaPart.customerPO" :disabled="true" class="form-control" />
                                        </b-form-group>
                                        <b-form-group label="Alternate PN" class="mr-2">
                                            <b-form-input v-model="rmaPart.altNumber" :disabled="true" class="form-control" />
                                        </b-form-group>
                                        <b-form-group label="NSN" class="mr-2">
                                            <b-form-input v-model="rmaPart.nsnNumber" :disabled="true" class="form-control" />
                                        </b-form-group>
                                        <b-form-group label="Harmonized Code" class="mr-2">
                                            <b-form-input v-model="rmaPart.harmonizedCode" :disabled="true" class="form-control" />
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="4">
                                        <b-form-group label="Qty" class="mr-2">
                                            <b-form-input :disabled="true" class="form-control" />
                                        </b-form-group>
                                        <b-form-group label="Returned" class="mr-2">
                                            <b-form-input v-model="rmaPart.qtyReturning" class="form-control"  />
                                        </b-form-group>
                                        <b-form-group label="Reason" class="mr-2">
                                            <b-form-select v-model="rmaPart.rmaReasonId" class="form-control">
                                                <option v-for="option in sortSelect(rmaReasons)" :key="option.name" :value="option.id">
                                                    {{ option.name }}</option>
                                            </b-form-select>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="8">
                                        <b-form-group label="Comments" class="mr-2">
                                            <b-textarea v-model="rmaPart.comments" class="form-control" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col cols="3">
                                <b-col>
                                    <b-form-group label="Serial Numbers" class="mr-2">
                                        <b-textarea v-model="rmaPart.serialNumbers" class="form-control" />
                                    </b-form-group>
                                </b-col>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
        </div>
        <template slot="modal-footer">
            <b-button variant="primary" @click="saveRMALine">Save</b-button>
            <b-button @click="$bvModal.hide(modalId)">Cancel</b-button>
        </template>
    </b-modal>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import GridSettings from '@/shared/components/GridSettings';
import { prepareColumnsData } from '@/shared/helpers';
import { date } from '@/shared/filters';
import GridComponent from '@/shared/components/GridComponent';
import gridFields from './fields';
import invoiceLineFields from '@/pages/Customerrmas/components/add/modifiedInvoiceLineField';
import inventoryUsedField from '@/pages/Customerrmas/components/add/inventoryUsedField';
import {GRID_ID} from '@/shared/constants';

export default {
    components: {
        GridComponent
    },
    props: {
        isAddPart: {
            type: Boolean,
            default: false
        },
        rmaPart: {
            type: Object,
            default: () => {}
        },
        rmaId: {
            type: [Number, String],
            default: 0
        }
    },
    data: () => ({
        lineFields: invoiceLineFields,
        inventoryField: inventoryUsedField,
        checkedRowItemIds: [],
        checkedInvoiceLineIds: [],
        checkedInventoryReturnedIds: [],
        prepareColumnsData,
        selectedRowItemLineId: 0,
        date,
        modalId: 'rma-part-modal',
        requiredPostFields: [
            'quantityReturning', 'rmaReasonId'
        ],
        invoiceLineArr: []
    }),
    computed: {
        ...mapGetters('account', ['gridSettingsById']),
        ...mapGetters('customerrmas', ['customerrma']),
        ...mapGetters('lookup', ['rmaReasons']),
        ...mapState('invoiceLines', ['invoiceLinesRma']),
        ...mapState('pickTicket', ['pickTicketLinesByInvoiceLine']),
        gridLineId: function() {
            return GRID_ID.INVOICES_LINES
        },
        gridInventoryId: function() {
            return GRID_ID.RMA_INVENTORY
        },
        gridSettings() {
            return this.gridSettingsById(this.gridId);
        },
        returnedInvoiceLine() {
            return this.invoiceLineArr.filter(x => this.checkedInvoiceLineIds.indexOf(x.id) > -1);
        },
    },
    methods: {
        ...mapActions('account', ['saveGridSettings']),
        ...mapActions('customerrmas', ['onAddRMALine', 'onUpdateRMALine']),
        ...mapActions('pickTicket', [ 'getPickTicketsByInvoiceLine' ]),
        ...mapActions('invoiceLines', ['getInvoiceLinesRma']),
        /*...mapMutations('pickTicket', [ 'setPickTicketLinesByInvoiceLine' ]),*/
      ...mapMutations('pickTicket', {pickTicketSetItem : 'setItem'}),
        async handleCheckedInvoiceLine(row) {
            if (this.checkedRowItemIds.length > 0) {
                await this.getPickTicketsByInvoiceLine(this.checkedRowItemIds);
            } else if (this.checkedRowItemIds.length == 0 ) {
                this.checkedInventoryReturnedIds = [];
                /*this.setPickTicketLinesByInvoiceLine([]);*/
              this.pickTicketSetItem({ resource: 'pickTicketLinesByInvoiceLine', payload: [] });
            }
        },
        getInvoiceLinesChecked() {
            return this.itemLineData.filter((item) => {
                return this.checkedRowItemIds.some((id) => {
                return id == item.id;
                })
            }).map(items => {
                delete items.selected;
                return items;
            });
        },
        async onRowLineClick(row) {
            this.selectedRowItemLineId = row.dataItem.id;
            await this.getPickTicketsByInvoiceLine(row.dataItem.id);
        },

        onClear() {
            if (this.isAddPart) {
                this.checkedRowItemIds = this.checkedInventoryReturnedIds = [];
                // this.setPickTicketLinesByInvoiceLine([]);
            }
        },
        getInvoiceLinesSelected() {
         return this.itemLineData.filter((item) => item.id == this.selectedRowItemLineId);
        },
        async saveRMALine() {
            if (this.isAddPart) {
                await this.onAddRMALine({
                    rmaId: this.rmaId,
                    returnedInvoiceLine: this.returnedInvoiceLine

                });
                this.$snotify.success('Added RMA Line', 'RMA');
            } else {
                await this.onUpdateRMALine({
                    rmaId: this.rmaId,
                    rmaLineId: this.rmaPart.id,
                    rmaLineDto: this.rmaPart
                });
                this.$snotify.success('Updated RMA Line', 'RMA');
            }

            this.onClear();
            this.$emit('onRefresh');
            this.$bvModal.hide(this.modalId);
        },
        isValidfields() {
            this.$snotify.info('Processing RMA', 'RMA');
            const h = this.$createElement
            let isValid = false;
            let errors = [];
            let validationMsg = h('ul', {}, errors);

            if(isValid = errors.length > 0){
              this.openAlertBox({message: validationMsg,title: 'Please correct the following'});
            }

            return isValid;
        },
    },
    watch: {
        checkedRowItemIds() {
            this.handleCheckedInvoiceLine();
        }
    },
    mounted() {
        if (this.customerrma.invoiceId) {
            this.getInvoiceLinesRma(this.customerrma.invoiceId).then(() => {
                this.invoiceLineArr = this.invoiceLinesRma.map((returnLine) => ({
                ...returnLine,
                returnQty: 0,
                returnReasonId: 0,
                returnComments: null
                }));
                this.checkedInvoiceLineIds = [];
            });
        }
    }
}
</script>
<style scoped>
.create-po-grid {
    height: auto !important;
}
table {
  width: 100%;
  cursor: context-menu;
}
td {
  padding-left: 10px;
  white-space: nowrap;
}
</style>